import { cn } from "@/lib/utils";

/** The card look shared by the period presets and the content-scope options. */
export function selectionClasses(selected: boolean): string {
  return cn(
    "flex min-h-20 w-full items-start gap-3 rounded-lg border p-3 text-left transition-colors",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
    selected
      ? "border-primary bg-primary/5 text-foreground"
      : "border-border bg-background hover:bg-muted/40"
  );
}
